<template>
        <div v-if="this.$store.getters.GetBlock.notifications">
            <div uk-alert class="uk-alert-danger " uk-scrollspy="cls:uk-animation-slide-top;">
                <a class="uk-alert-close" uk-close></a>
                <h2>Примечание!</h2>
                <h3>Обращаем внимание на то, что бронированием номеров участники занимаются самостоятельно.</h3>
            </div>
        </div>
        <div v-if="this.$store.getters.Loaded && this.$store.getters.GetBlock.rezident" class="uk-container uk-container-center uk-text-center uk-margin-top " style="background-image: none;" uk-scrollspy="cls:uk-animation-slide-bottom;">
        <h1 class="uk-heading" id="living">{{this.$store.getters.GetText.rezident.title[this.$store.getters.Lang]}}</h1>
        
        <h3>{{this.$store.getters.GetText.rezident.subtitle[this.$store.getters.Lang]}}</h3>
        <div class="uk-child-width-1-2@s uk-grid-match" uk-grid>
            <div>
                <div class="uk-card uk-card-hover uk-card-body" uk-scrollspy="cls:uk-animation-slide-bottom;">
                    <h3 class="uk-card-title">Три медведя</h3>
                    <a href="https://go.2gis.com/ilcuuc" target="_blank"><span uk-icon="icon: location"></span>Ленинградская, 11</a><br>
                    <a href="tel:+7 (391) 243‒36‒13"><span uk-icon="icon: receiver"></span> +7 (391) 243‒36‒13</a><br>
                    <a href="tel:+7 (391) 243‒36‒13"><span uk-icon="icon: receiver"></span> +7 (391) 222‒49‒91</a><br>
                    <a href="www.3bear.ru" target="_blank"><span uk-icon="icon: world"></span> www.3bear.ru</a>
                </div>
            </div>
            <div>
                <div class="uk-card uk-card-hover uk-card-body" uk-scrollspy="cls:uk-animation-slide-bottom;">
                    <h3 class="uk-card-title">Гараж</h3>
                    <a href="https://go.2gis.com/rmsqu5" target="_blank"><span uk-icon="icon: location"></span>8 Марта, 24Б</a><br>
                    <a href="tel:+7 (391) 243‒36‒13"><span uk-icon="icon: receiver"></span> +7 (391) 2‒900‒282</a><br>
                    <a href="tel:+7 (391) 243‒36‒13"><span uk-icon="icon: receiver"></span> +7 (391) 2‒900‒007</a><br>
                    <a href="http://xn--80aaajbuja8bi2afn3d.xn--p1ai/" target="_blank"><span uk-icon="icon: world"></span> гостиницагараж.рф</a>
                </div>
            </div>
            <div>
                <div class="uk-card uk-card-hover uk-card-body" uk-scrollspy="cls:uk-animation-slide-bottom;">
                    <h3 class="uk-card-title">Сапфир</h3>
                    <a href="https://go.2gis.com/w20vf" target="_blank"><span uk-icon="icon: location"></span>Высотная, 4</a><br>
                    <a href="tel:+7 (391) 209‒52‒09"><span uk-icon="icon: receiver"></span> +7 (391) 209‒52‒09</a><br>
                    <a href="tel:+7 (391) 291‒32‒85"><span uk-icon="icon: receiver"></span> +7 (391) 291‒32‒85</a><br>
                    <a href="tel:+7 (391) 291‒32‒84"><span uk-icon="icon: receiver"></span> +7 (391) 291‒32‒84</a><br>
                    <a href="https://xn----7sbbjzad9ahqmdfi2b0a.xn--p1ai/" target="_blank"><span uk-icon="icon: world"></span> гостиница-сапфир.рф</a>
                </div>
            </div>
            <div>
                <div class="uk-card uk-card-hover uk-card-body" uk-scrollspy="cls:uk-animation-slide-bottom;">
                    <h3 class="uk-card-title">Miniotel24</h3>
                    <a href="https://yandex.ru/maps/-/CCUru6cwkC" target="_blank"><span uk-icon="icon: location"></span> Куйбышева, 97Г </a><br>
                    <a href="tel:+7 (953) 841-00-85"><span uk-icon="icon: receiver"></span> +7 (953) 841-00-85</a><br>
                    <a href="tel:+7 (391) 226-88-44"><span uk-icon="icon: receiver"></span> +7 (391) 226-88-44</a><br>
                    <a href="https://www.tripadvisor.ru/Hotel_Review-g298525-d1566538-Reviews-Miniotel_24-Krasnoyarsk_Krasnoyarsk_Krai_Siberian_District.html" target="_blank"><span uk-icon="icon: tripadvisor"></span> tripadvisor.ru</a>
                </div>
            </div>
        </div>
    </div>
    <div class="uk-container">
        <Yamap/>
    </div>
</template>
<script>
//import Yamap from './Yamap.vue'

export default {
    setup() {
        
    },
    components: {
       //Yamap
    } 
}
</script>






